import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/prospects")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Prospects"
    };
  }
});

function RouteComponent() {
  return <Outlet />;
}
